/* eslint-disable spire/export-styles */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation"; // Husky Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
// import Menu from "@insite/mobius/Menu"; // Husky Custom Code
import Popover from "@insite/mobius/Popover";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";

/* Husky Custom Code  - Start */
import Menu, { MenuItemStyle, MenuStyle } from "@husky-hrc/MobiusOverrides/Menu/Menu";
import { MainNavigationStyles, MappedLink } from "@husky-hrc/Overrides/Widgets/Header/MainNavigation";
import { moveFocus } from "@husky-hrc/Utilities/Utilities";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import { connect } from "react-redux";
import { css } from "styled-components";
/* Husky Custom Code  - End */

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
    // Husky Custom Code
    isAuthenticated: boolean;
}

/* Husky Custom Code  - Start */
interface State {
    open?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const isAuthenticated = state.context.session.isAuthenticated;
    return {
        isAuthenticated,
    };
};

type Props = ThemeProps<BaseTheme> & ReturnType<typeof mapStateToProps> & OwnProps;
/* Husky Custom Code  - End */

class MainNavigationItem extends React.Component<Props, State> /* Husky Custom Code */ {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    /* Husky Removed - componentDidUpdate */

    /* Husky Custom Code - Start */
    constructor(props: Props) {
        super(props);

        this.state = {
            open: false,
        };
    }
    /* Husky Custom Code - End */

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    /* Husky Custom Code - Start */
    onKeyDownHandler = (e: React.KeyboardEvent, index: number, isDropdown: boolean | undefined) => {
        if (isDropdown) {
            const key = e.nativeEvent.code.toLowerCase();
            const navItemSelector = `div[data-test-selector='mainNavigationItem_${index}']`;
            const childItems = [...document.querySelectorAll(`${navItemSelector} ${MenuItemStyle}`)] as HTMLElement[];

            if (key === "enter" || key === "space") {
                if (key === "space") {
                    e.preventDefault();
                }
                this.setState({
                    open: !this.state.open,
                });
            } else if ((key === "arrowdown" || key === "arrowup") && this.state.open) {
                e.preventDefault();
                moveFocus(key, childItems, true);
            } else if ((key === "tab" || key === "escape") && this.state.open) {
                this.setState({
                    open: false,
                });
            } else {
                moveFocus(e.key, childItems, true);
            }
        }
    };

    onBlurHandler = (e: React.FocusEvent) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node) && this.state.open) {
            this.setState({ open: false });
        }
    };

    handleMenuLinkClick = (e: React.MouseEvent) => {
        this.setState({ open: !this.state.open });
    };

    handleMenuHover = () => {
        this.setState({ open: true });
    };

    handleMenuMouseOut = (e: React.MouseEvent) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node) && this.state.open) {
            this.setState({ open: false });
        }
    };

    linkVisible = (link: any) => {
        if (this.props.isAuthenticated) {
            return (
                (link.url || link.singleLinkType === "sign-in") &&
                (link.linkDisplay === "authenticated" || link.linkDisplay === "both")
            );
        }
        return (
            (link.url || link.singleLinkType === "sign-in") &&
            (link.linkDisplay === "unauthenticated" || link.linkDisplay === "both")
        );
    };
    /* Husky Custom Code - End */

    render() {
        const {
            styles,
            link,
            index,
            /* Husky Removed - isOpen */
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        const isMega = hasChildren && link.childrenType === "MegaMenu";

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.url}
                target={link.openInNewWindow ? "_blank" : ""}
                // Husky Custom Code
                onClick={this.handleMenuLinkClick}
                aria-expanded={this.state.open}
                aria-label={
                    this.state.open
                        ? `${link.title} - ${translate("Collapse Menu")}`
                        : `${link.title} - ${translate("Expand Menu")}`
                }
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                </Link>
            );
        }

        /* Husky Custom Code - Start */
        if (link.url && link.url !== "/") {
            const override = {
                menuItem: {
                    css: css`
                        :hover::after {
                            content: "";
                            position: absolute;
                            bottom: -3px;
                            width: 100%;
                            border-bottom: 4px solid ${getColor("danger.main")};
                        }
                    `,
                },
            };
            const stylesNew = mergeToNew(styles, override);
            menuLink = (
                <Link
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...stylesNew.menuItem}
                    href={link.url}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                </Link>
            );
        }
        /* Husky Custom Code - End */

        let menuItem = menuLink;

        if (isCascading && link.children) {
            /* Husky Custom Code - Start */
            const linkChildren = [] as any;

            if (link.children) {
                link.children.map(item => {
                    return !item.linkDisplay
                        ? linkChildren.push(item)
                        : this.linkVisible(item)
                        ? linkChildren.push(item)
                        : "";
                });
            }
            /* Husky Custom Code - End */

            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    /* Husky Removed - isOpen */
                    descriptionId={`${link.title}_${index}`}
                    menuItems={linkChildren}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                    // Husky Custom Code
                    onMouseOver={this.handleMenuHover}
                    onMouseOut={this.handleMenuMouseOut}
                    onBlur={this.onBlurHandler}
                    onKeyDown={e => this.onKeyDownHandler(e, index, isCascading || isMega)}
                    width={200}
                    cssOverrides={{
                        menu: css`
                            border-top: 4px solid ${getColor("danger.main")};
                            ${this.state.open ? "display: block" : "display: none"}
                        `,
                        menuItem: css`
                            a {
                                display: flex;
                            }
                            a > span {
                                padding: 0;
                                margin: 10px 15px 10px 20px;
                            }
                            a:hover {
                                background-color: ${getColor("common.accent")};
                                span {
                                    border-left: 4px solid ${getColor("danger.main")};
                                    padding-left: 8px;
                                    color: ${getColor("danger.main")};
                                }
                            }
                            button {
                                cursor: initial;
                            }
                            button > span {
                                text-transform: uppercase;
                                color: #767676;
                                font-size: 13px;
                                font-weight: bold;
                            }
                        `,
                        wrapper: css`
                            ${this.state.open
                                ? `
                                    > ${MenuStyle} {
                                        display: block !important;
                                    }
                                `
                                : `
                                    > ${MenuStyle} {
                                        display: none !important;
                                    }
                                `}
                        `,
                    }}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1140,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                        if (this.props.container.current?.offsetParent) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;
                            /* Husky Removed - cartWidth */
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return parentPosition.width <= value && parentPosition.width > maxWidths[index - 1]; // Husky Custom Code
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                top,
                                position: "fixed",
                                left: parentPosition.left,
                                width: `${width}px`,
                            };
                        }
                        return { position: "absolute" };
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                >
                    <GridContainer
                        className="mega-menu-grid-container"
                        data-test-selector={`mainNavigationItem_${index}`}
                        {...styles.megaMenuGridContainer}
                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                    >
                        {link
                            .children!.filter(child => !child.excludeFromNavigation)
                            .map((child, index) => (
                                <GridItem
                                    className="mega-menu-grid-item"
                                    width={(12 / link.numberOfColumns!) as GridWidths}
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                    {...styles.megaMenuGridItem}
                                    as="li"
                                >
                                    <Link
                                        className="mega-menu-heading-link"
                                        {...styles.megaMenuHeading}
                                        href={child.url}
                                        onClick={this.closePopover}
                                    >
                                        {child.title}
                                    </Link>
                                    {child.children && (
                                        <ul data-test-selector={`linksFor_${child.title}`}>
                                            {child.children
                                                .filter(grandChild => {
                                                    if (grandChild.excludeFromNavigation) {
                                                        return false;
                                                    }
                                                    if (
                                                        grandChild.type === "ChangeCustomerPage" &&
                                                        !this.props.displayChangeCustomerLink
                                                    ) {
                                                        return false;
                                                    }
                                                    if (grandChild.type === "VmiUsersPage") {
                                                        const currentMode = getCookie(NavigationModeCookieName);
                                                        if (!currentMode || currentMode === "Storefront") {
                                                            return false;
                                                        }
                                                    }

                                                    return true;
                                                })
                                                .map((grandChild, index) => (
                                                    // eslint-disable-next-line react/no-array-index-key
                                                    <li key={index}>
                                                        <Link
                                                            className="mega-menu-link"
                                                            {...styles.megaMenuLink}
                                                            onClick={this.closePopover}
                                                            href={grandChild.url}
                                                            data-test-selector={grandChild.title}
                                                        >
                                                            {grandChild.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                        </ul>
                                    )}
                                </GridItem>
                            ))}
                    </GridContainer>
                </Popover>
            );
        }

        return menuItem;
    }
}

export default withTheme(connect(mapStateToProps)(MainNavigationItem)); // Husky Custom Code
